import LockSolidSVG from "@design-system/ui-icons/vanilla/LockSolid"
import { createIcon } from "../createIcon"

export const LockSolidIcon = createIcon(LockSolidSVG)
